module.exports = __webpack_public_path__ + "img/MiddleSchoolAvatar03.ea4097f7.svg";